define.alias("shared/decorators/track-call-duration", "auth/decorators/track-call-duration");